module.exports = __webpack_public_path__ + "static/media/signet.3344f1e7.png";